import { renderForCriticalMoment } from "../dashHelper";
import encuestaNps from "./staticDashboards/encuestaNps";
import general from "./staticDashboards/general";
import integracion from "./staticDashboards/integracion";
import encuestaEcommerce from "./staticDashboards/encuestaEcommerce";
import encuestaCsat from "./staticDashboards/encuestaCsatCes";

export default {
  title: 'Default Dashboard',
  description: 'Dashboard de perfil Default',
  backgroundClassName: (filters: any) => 'epsilon-hero-bg',
  widgets: (filters: any, filtersData: Record<string, any>) => {

    let allWidgets = [
      ...general.widgets(filters, filtersData).map((w: any) => ({ ...w, render: (f: any) => renderForCriticalMoment(f, [29]) })),
      ...integracion.widgets(filters, filtersData).map((w: any) => ({ ...w, render: (f: any) => renderForCriticalMoment(f, [12701]) })),
      ...encuestaNps.widgets(filters, filtersData).filter((w: any) => w.id !== 'Nps-por-segmento' && w.id !== 'Nps-por-giro').map((w: any) => ({ ...w, render: (f: any) => renderForCriticalMoment(f, [12702]) })),
      ...encuestaEcommerce.widgets(filters, filtersData).map((w: any) => ({ ...w, render: (f: any) => renderForCriticalMoment(f, [5192550]) })),
      ...encuestaCsat.widgets(filters, filtersData).map((w: any) => ({ ...w, render: (f: any) => renderForCriticalMoment(f, [16750]) })),
    ];

    return allWidgets;
  },
} as DasboardConfig;
